<template>
    <div id="repeaTopic" class="publicViewClass">
            <div class="app-inner show_container" style="padding:16px 0 !important;margin-bottom:80px">
      <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  @click="$util.reback('/teacheManage/questionList')" style="margin-left:0">
                返回
            </div>
            </div>
         <div class="public-tit flex align-cen" style="margin:0 10px">
            <div class="public-tit-list">
                <i class="icon-al-copy"></i>  题库查重
            </div>
            <div class="mft tips" v-if="arrRe.length" style="color:red">
                系统检测到共有  {{arrRe.length}} 道重复试题，请检查处理
            </div>
        </div>
        <!-- 去重列表 -->
        <div class="question-duplication-container staff_manage_center" style="margin-top:0">
             <div class="public-list-container">
                 <div class="public-list-container-table">
                    <div class="public-list-container-table-header flex align-cen">
                            <div class="stclass pustclass">排序</div>
                            <div class="stsort pustclass">题目标题</div>
                            <div class="stcz pustclass">题型</div>
                            <div class="stcz1 pustclass">重复次数</div>
                            <div class="stcz2 pustclass"></div>
                        </div>
                         <div v-if="arrRe.length">
                        <div class="public-list-container-table-row"
                        v-for="(item,index) in arrRe"
                        >
                        <div class="flex align-cen" :class="item.isTrue ? 'pdd' : ''">
                          <div class="stclass pustclass">
                            {{index+1}}
                          </div>
                          <div class="stsort pustclass">
                            <p v-html="item.title"></p>
                          </div>
                           <div class="stcz pustclass">
                            {{$util.getTopicType(item.type)}}
                           </div>
                           <div class="stcz1 pustclass" style="color:red">
                            {{item.duplicateNum}}
                           </div>
                           <div class="stcz2 pustclass" style="color:red;cursor: pointer;" @click="openTopicRe(item.isTrue,index,item.duplicateList)">
                                {{item.isTrue ? '暂不处理' : '展开处理' }}
                           </div>
                           </div>
                           <div class="topicIstru" v-if="item.isTrue">
                                <div class="duplicate-questions flex">
                                    <div class="duplicate-question" v-for="(childItem,childIndex) in item.duplicateList">
                                        
                                        <div class="portlet">
                                            <div class="portlet-head flex align-cen">
                                                <div class="caption">试题{{childIndex+1}}</div>
                                                <div class="btn-set mft flex align-cen">
                                                   <div class="btn-blue-delete" @click="deletTopic(childItem.id)">删除</div>
                                                    <div class="btn-default" @click="editTopic(childItem.id)">编辑</div>
                                                </div>
                                            </div>
                                            <div class="portlet-body">
                                                <div class="duplication-info-container">
                                                    <div class="ques-title flex align-cen">
                                                        <span class="ques-type">
                                                             {{$util.getTopicType(childItem.type)}}
                                                        </span>
                                                        <div class="qcotent">
                                                            <p v-html="childItem.title" :class="childItem.type == 9 ? 'clozeClass' : ''"></p>
                                                        </div>
                                                        <div class="ques-score">
                                                            ({{childItem.score}}分)
                                                        </div>
                                                    </div>
                                                    <div class="question-option-list">
                                                        <ol  v-if="childItem.type != 9 && childItem.type != 5">
                                                            <li v-for="(sonitem,sonIndex) in childItem.answerList">
                                                               <p v-html="sonitem.content"></p>
                                                            </li>
                                                        </ol>
                                                             <div class="refAnswer" style="margin-left:-25px" v-if="childItem.type == 5">
                                                <div class="detailKeyWorld" v-if="childItem.rule">
                                                    <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                                    <p>关键字：</p>
                                                        <p v-for="(sonitem,sonIndex) in childItem.answerList">
                                                        {{sonitem.content}}<span v-if="sonIndex !=childItem.answerList.length-1">，</span>
                                                    </p>
                                                    </div>
                                                </div>
                                                <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                                            </div>
                                            <div class="clzoe" v-if="childItem.type == 9">
                                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in childItem.answerList" :key="sonIndex">
                                                <p class="cloze-op-p">
                                                    <strong> {{sonIndex + 1}}:</strong>
                                                </p>
                                                <ol style="margin-left:20px">
                                                    <li  v-for="(sonitem1,sonIndex1) in childItem.answerList[sonIndex].clozeList" :key="sonIndex1">
                                                        <p v-html="sonitem1.content"></p>
                                                    </li>
                                                </ol>
                                                </div>
                                            </div>
                                                    </div>
                                                    <div class="ques-answers">
                                                        <div class="test_result">
                                                            <div class="rightAnswer flex">
                                                                <span v-if="childItem.type != 7 && childItem.type != 9 && childItem.type != 5">
                                                                    正确答案：
                                                                    <span v-for="(sonitem,sonIndex) in childItem.answerList">
                                                                     <strong  v-if="sonitem.isRight == 1">
                                                                        {{Eng[sonIndex]}}
                                                                    </strong>
                                                                    </span>
                                                                </span>
                                                                 <span v-if="childItem.type == 5" class="flex align-cen" style="color:#009aff">
                                                            参考答案：
                                                            <span v-html="childItem.refAnswer"></span>
                                                        </span>
                                                         <span v-if="childItem.type == 7">
                                                                    正确顺序：
                                                                    <span v-for="(sonitem,sonIndex) in sortedIndexes">
                                                                        <span>
                                                                        {{Eng[sonitem]}}
                                                                    </span>
                                                                    </span>
                                                                </span>
                                                                 <span v-if="childItem.type == 9">
                                                                正确顺序：
                                                                <span v-for="(sonitem,sonIndex) in childItem.answerList">
                                                                            <span style="margin-right:20px">
                                                                            {{sonIndex + 1}}:
                                                                            <span v-for="(sonitem1,sonIndex1) in childItem.answerList[sonIndex].clozeList" :key="sonIndex1">
                                                                                <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                                            </span>
                                                                            </span>
                                                                </span>
                                                            </span>
                                                            </div>
                                                              <div class="rightAnswer flex">
                                                                <span>
                                                                    分数：
                                                                   
                                                                     <strong >
                                                                        {{childItem.score}}
                                                                    </strong>
                                                                    
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                        </div>
                       </div>
                       <div v-else class="no-empry">
                            暂无数据
                        </div>
                 </div>
             </div>
        </div>
    </div>
    <!-- 打开题目编辑 -->
        <el-dialog
  title="编辑题目"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
  <div class="forminfo"> 
      <topicTemplate 
    :topicID='topicID'
    ref="topicTemplate"
    ></topicTemplate>
    <div class="authbtn flex align-cen">
             <el-button plain @click="centerDialogVisible = false">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit">确认</el-button>
        </div>
  </div>
        </el-dialog>
    </div>
</template>
<script>
import { questionRepeat,getEnQuestion} from "@/api/enterprise/index"; // 题库去重、删除试题
import topicTemplate from "@/weteacheManage/questionList/addQuestion/index.vue"; //将题目列表页面作为组件使用
export default {
    name:'repeaTopic',
    components:{
        topicTemplate
    },
    data () {
        return {
            topicID:'',
            centerDialogVisible:false,
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            arrRe:[],
            businessInfo:{},
            sortedIndexes:[]
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getRepeatInfo()
    },
    methods: {
        // 编辑试题
        editTopic(id){
            this.topicID = id
            this.centerDialogVisible = true
        },
        onSubmit(){
             this.$refs.topicTemplate.onSubmit()  
                 setTimeout(() => {
                 this.centerDialogVisible = false 
                 this.getRepeatInfo()
             }, 500);
              
        },
        // 删除试题
        deletTopic(id){
          this.$confirm('您确定要删除该试题吗？删除后会影响添加了该题的试卷，请您谨慎操作！?', '删除试题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getEnQuestion({
              id:id,
              businessId:this.businessInfo.id
              },'delete','enterprise')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')        
                   this.getRepeatInfo()
              })
              .catch(err => {
              })
        })
        },
        // 展开处理
        openTopicRe(isTrue,index,data){
            this.arrRe[index].isTrue = !isTrue
             data.forEach((t,index) => {
                if(t.type == 7){
                           // 创建一个包含原数组索引和值的数组  
                        let indexedArray = t.answerList.map((item, index) => ({ item, index }));  
                        // 根据sort值进行排序  
                        indexedArray.sort((a, b) => a.item.sort - b.item.sort);      
                        // 提取排序后的索引  
                        this.sortedIndexes = indexedArray.map(item => item.index);  
                }
             });
        },
        getRepeatInfo(){
            this.arrRe = []
            const loading = this.$loading({
              lock: true,
              text: '查重中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            questionRepeat({businessId:this.businessInfo.id},'enterprise')
            .then(res => {
                loading.close()
                let arr = res.data
              arr.forEach(e => {
                e['isTrue'] = false
              });
              this.arrRe = arr
            })
            .catch(err => {
                loading.close()
                this.$util.Notifi(err.message || '查重失败，请稍后重试','error','fa-exclamation-circle')
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.repeaTopic{
    margin-bottom: 40px;
}
.forminfo{
    margin-top: -50px;
}
.public-list-container{
    position: relative;
    .public-list-container-table{
         .pustclass{
            width: 15%;
            text-align: center;
          }
          .stsort{
            width: 40% !important;
            text-align: center;
             overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap
          }
        .public-list-container-table-row {
            padding: 30px 0 !important;
            .pdd{
                padding-bottom: 30px;
            }
           
        }
        .topicIstru{
                border-top: solid 1px #ccc;
                padding: 30px 10px;
            .duplicate-questions{
                
                .duplicate-question{
                    max-width: 50%;
                    flex: 1 1 50%;
                    padding-right: 15px;
                    padding-left: 15px;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                    .portlet{
                        background: #fafafa;
                        padding: 16px 10px !important;
                        border-radius: 5px;
                        .portlet-head{
                            border-bottom: 0;
                            padding: 0 10px;
                            margin-bottom: 0;
                            color: #fff;
                            .caption{
                               font-size: 16px;
                                color: #333;
                                font-weight: 600;
                                padding: 11px 0 9px 0;
                            }
                            .btn-set{
                                .btn-blue-delete{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #36aafd;
                                    border: 1px solid #36aafd;
                                    padding: 8px 25px !important;
                                    border-radius: 4px !important;
                                    box-sizing: border-box;
                                    margin-right: 5px;
                                }
                                .btn-default{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #fff;
                                    background-color: #36aafd;
                                    padding: 8px 25px !important;
                                    border: 1px solid #36aafd;
                                    border-radius: 4px !important;
                                }
                            }
                        }
                        .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 70px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            color: #36aafd;
                                            display: block;
                                            font-size: 16px;
                                       } 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
::v-deep{
    .el-dialog{
        margin-top: 5vh !important;
    }
}
</style>